import React from "react";
import "./style.scss";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const DashboardCard = ({
  icon = () => {},
  title,
  subTitle,
  tamdid = false,
  onClick,
  loading = false,
}) => {
  return (
    <div className="dashboard-card">
      <div className="icon">{icon()}</div>
      <div className="text-card">
        <p className="fs-15 fw-700 lh-26 text-sub">{title}</p>
        <div style={{ display: "flex", gap: 10 }} className="tamdid-error">
          <p className="fs-15 fw-700 lh-26 text-main num" data-error={tamdid}>
            {subTitle}
          </p>
          {tamdid && (
            <button
              onClick={onClick}
              style={{ alignSelf: "end" }}
              className="fs-10 fw-600 lh-17"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spin
                    indicator={
                      <LoadingOutlined
                        color="#000"
                        style={{ color: "#000" }}
                        spin
                      />
                    }
                  />
                </>
              ) : (
                <>تمدید اشتراک</>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardCard;
